import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_PROCESS_IOU: 'FETCH_PROCESS_IOU',
  RESET: 'RESET',
}

const fetchReset = async (state) => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchProcessIou = async (state, processiou) => {
  state = {
    ...state,
    isStatus: processiou.status,
    expireToken: sanitizeExpire({
      status: processiou.status,
      data: processiou.data,
      name: 'processiouobj',
    }),
    data: sanitizeData({
      status: processiou.status,
      data: processiou.data,
      name: 'processiouobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROCESS_IOU:
      return fetchProcessIou(state, action.processiou)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const processiou = {
  init,
  actionTypes,
  reducer,
}

export default processiou
